module.exports = __webpack_public_path__ + "static/media/download.6e8e4829.svg";